import { useContext } from "react";
import { LandingPageContext } from "../context/LandingPageContextProvider";

export function useLandingPageContext() {
    const useLandingPageContext = useContext(LandingPageContext);
    if (useLandingPageContext == null) {
        throw new Error("Please provide a context properly!")
    }
    return useLandingPageContext;
}